import { baseUrl } from "../api";

export const emailUrl = `${baseUrl}email/`;
export const supportEmailUrl = `${emailUrl}support/`;
